import axios from 'axios'
import swal from 'sweetalert';

export const ufe_avance_academico = (data) => {
    return axios
        .post(
            'https://ws.ugm.cl/api/v1_ufe/ufe_avance_academico' , data,
            {
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_TOKEN
                 }
            }
        )
        .then(response => {
            //console.log('ufe_avance_academico', response.data)
            return response.data
        })
        .catch(err => {
            //console.log(err)
            return swal(err.data)
        })
}




export const ufe_updateDatosCae = (data) => {
    return axios
        .post(
            'https://ws.ugm.cl/api/v1_ufe/ufe_actualizarDatosCae' , data,
            {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': process.env.REACT_APP_TOKEN
                 }
            }
        )
        .then(response => {
            //console.log('ufe_updateDatosCae', response.data)
            return swal(response.data)
        })
        .catch(err => {
            //console.log(err)
            return swal(err.data)
        })
}





export const ufe_cae_agregarArchivo = (data) => {
    return axios
        .post(
            'https://ws.ugm.cl/api/v1_ufe/ufe_cae_agregarArchivo' , data,
            {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    'Authorization': process.env.REACT_APP_TOKEN
                    
                 }
            }
        )
        .then(response => {
            //console.log('ufe_cae_agregarArchivo', response.data)
            return swal(response.data)
        })
        .catch(err => {
            //console.log(err)
            return swal(err.data)
        })
}




export const ufe_listarArchivos = (data) => {
    return axios
        .post(
            'https://ws.ugm.cl/api/v1_ufe/ufe_listarArchivos' , data,
            {
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_TOKEN
                    
                 }
            }
        )
        .then(response => {
            //console.log('ufe_listarArchivos', response.data)
            return response.data
        })
        .catch(err => {
            //console.log(err)
            return swal(err.data)
        })
}




export const ufe_eliminarArchivo = (data) => {
    return axios
        .post(
            'https://ws.ugm.cl/api/v1_ufe/ufe_eliminarArchivo' , data,
            {
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': process.env.REACT_APP_TOKEN
                    
                 }
            }
        )
        .then(response => {
            //console.log('ufe_listarArchivos', response.data)
            return swal(response.data)
        })
        .catch(err => {
            //console.log(err)
            return swal(err.data)
        })
}




